export const LEFT_VARIANT = 'left' as const;
export const RIGHT_VARIANT = 'right' as const;
